/**
 * Source for device info
 * @module
 */

var UAParser = require('core/utils/ua_parser');

/**
 * Get device info from userAgent
 * @returns {string}
 */
exports.getDevice = function(): string {
  var device = UAParser.get().device;

  if (device.model !== 'unknown') {
    return device.model;
  }

  if (device.type === 'tablet') {
    return 'tablet';
  }

  if (device.isMobile) {
    // Devices that aren't iPhone, iPad, or other tablet, but are running
    // an OS that is known to only be on phones and tablets.
    return 'mobile';
  } else {
    return 'desktop';
  }
};

